import {
  DEFAULT_DOMAIN_ID
} from '@/common/constants/domains.constants';
import { TAG_SYSTEM } from '@/common/constants/tags.constants';
import { STATE_ICON_DISABLED, STATE_ICON_ENABLED } from '@/common/utils/statuses';
import { enabledDisabledFormatter } from '@/common/utils/formatter.bool';

export type StoreDomainModel = {
  id: ID;
  tags: Array<string>;
  isDeletable: boolean;
  projectsCount: number;
  statusText: string;
  statusIcon: string;
} & Partial<Domain>;

function domain(attributes: Domain): Nullable<StoreDomainModel> {
  if (!attributes?.id) {
    return null;
  }

  const {
    id,
    enabled,
    projects_count,
    ...restAttrs
  } = attributes;

  const status = {
    statusText: enabledDisabledFormatter(enabled),
    statusIcon: enabled ? STATE_ICON_ENABLED : STATE_ICON_DISABLED
  };

  return {
    ...restAttrs,
    ...status,
    id,
    enabled,
    isDeletable: id !== DEFAULT_DOMAIN_ID && !projects_count,
    projectsCount: projects_count,
    tags: id === DEFAULT_DOMAIN_ID ? [TAG_SYSTEM] : []
  };
}

export default domain;
